/**
 * GlassValueDisplay Component
 * Displays glass value labels from IDs using the dropdown API
 */

import React from 'react';
import { useGetGlassValuesDropdownQuery, useGetPatternedGlassOptionQuery } from '../../store/slices/apiSlice';
import { formatGlassParts } from '../../utils/formatGlassSideDisplay';

interface GlassValueDisplayProps {
  glassValueId: string | null | undefined;
  /** Fallback when no GlassValue match (e.g. WooCommerce raw string) */
  rawFallback?: string | null;
  /** Patterned subtype option id (separate catalog row); shown after main label with ", " */
  patternedOptionId?: string | null | undefined;
  /** Raw Woo pattern label fallback when option id is not resolved yet. */
  patternedRawFallback?: string | null | undefined;
  className?: string;
}

export const GlassValueDisplay: React.FC<GlassValueDisplayProps> = ({
  glassValueId,
  rawFallback,
  patternedOptionId,
  patternedRawFallback,
  className,
}) => {
  const { data } = useGetGlassValuesDropdownQuery({});
  const { data: patterned } = useGetPatternedGlassOptionQuery(patternedOptionId!, {
    skip: !patternedOptionId,
  });

  let main = '';
  if (glassValueId) {
    const option = data?.results?.find((o) => o.value === glassValueId);
    main = option?.label || '';
  }
  if (!main && rawFallback && String(rawFallback).trim()) {
    main = rawFallback.trim();
  }

  const patternPart =
    patterned?.label?.trim() || (patternedRawFallback ? patternedRawFallback.trim() : '');

  const displayText = formatGlassParts(main, patternPart);
  if (displayText === '-') {
    return <>-</>;
  }
  return <span className={className}>{displayText}</span>;
};
